import { useTableColumns } from '@/creditflowresearch/ui/components/deals/DealListTable/columns/ABSIssueColumns';
import DealData from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealData';
import GenericTable, {
  IGenericTableProps,
} from '@/creditflowresearch/ui/components/deals/DealListTable/components/GenericDealListTable';
import { useDealTooltipContext } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import { useRowsExpandedContext } from '@/creditflowresearch/application/Deal/contexts/RowsExpandedContext';

export const DealPageTable = ({
  showDealDetailsByDefault, ...props
}: Partial<IGenericTableProps<any>> & { showDealDetailsByDefault?: boolean }) => {
  const { deal } = useDealPageContext();

  const { isRowsExpanded } = useRowsExpandedContext();

  const { onClick } = useDealTooltipContext();

  const columns = useTableColumns();

  return (
    <GenericTable
      columns={ columns }
      collection={ [deal] }
      isRowsExpanded={ isRowsExpanded }
      expandableRowContent={
        (rowData) => (
          <DealData { ...rowData } showDealDetailsByDefault={ showDealDetailsByDefault } />
        )
      }
      dataTest="dealsList"
      onRowClick={ (event, params) => onClick(event, params.row.id) }
      { ...props }
    />
  );
};

export default DealPageTable;
